// CAISSE-VDF-3 : outils purs du médecin demandeur des lignes de facture (testés par tests/caisse-medecin-demandeur).
// Un identifiant seul n'est affiché que s'il correspond à un praticien de l'annuaire, jamais à un simple caissier.

export const ROLES_DEMANDEURS = ['ROLE_SAGE_FEMME', 'ROLE_RADIOLOGUE', 'ROLE_INFIRMIER',
    'ROLE_INFIRMIER_MEDECINE_TRAVAIL', 'ROLE_TECHNICIEN_IMAGERIE', 'ROLE_TECH_SUP_LABO',
    'ROLE_PHARMACIEN', 'ROLE_PHARMACIEN_INTERMITENT']

export function estDemandeur(personnel) {
    const roles = personnel && Array.isArray(personnel.roles) ? personnel.roles : []
    return roles.some((role) => {
        const nom = role && typeof role === 'object' ? String(role.nom || role.name || '') : String(role || '')
        return nom.indexOf('ROLE_MEDECIN') === 0 || ROLES_DEMANDEURS.indexOf(nom) >= 0
    })
}

// Annuaire des praticiens ; nom d'export historique conservé pour les écrans de factures existants.
export function annuaireMedecins(personnels) {
    const annuaire = {}
    ;(Array.isArray(personnels) ? personnels : []).forEach((p) => {
        if (p && p.id && estDemandeur(p)) annuaire[String(p.id)] = { nom: p.nom || p.name || '', titre: p.titre || '' }
    })
    return annuaire
}

export function nomAffiche(nom, titre) {
    const brut = String(nom || '').trim()
    // Certains anciens bulletins ont enregistré « spécialité Dr Nom » dans medecin_nom.
    // Le titre marque le début du nom ; ne pas deviner si aucun titre n'est présent.
    const marqueur = /\b(?:Dr\.?|Docteur|Pr\.?|Professeur)\s+\S/i.exec(brut)
    const n = marqueur && marqueur.index > 0 ? brut.slice(marqueur.index) : brut
    if (!n) return ''
    const t = String(titre || '').trim()
    if (!t || !/^(?:Dr\.?|Docteur|Pr\.?|Professeur)$/i.test(t) || /^(?:Dr\.?|Docteur|Pr\.?|Professeur)\s/i.test(n) || n.toLowerCase() === t.toLowerCase()) return n
    return t + ' ' + n
}

// Uids distincts des lignes d'une facture groupée ({ operations: [{ prestations: [{ uid }] }] })
export function uidsFacture(facture) {
    const uids = []
    const groupes = facture && Array.isArray(facture.operations) ? facture.operations : []
    groupes.forEach((groupe) => {
        const lignes = groupe && Array.isArray(groupe.prestations) ? groupe.prestations : []
        lignes.forEach((ligne) => {
            const uid = ligne && ligne.uid ? String(ligne.uid) : ''
            if (uid && uids.indexOf(uid) < 0) uids.push(uid)
        })
    })
    return uids
}

// Nom d'un médecin : nom recopié, sinon identifiant présent dans l'annuaire des médecins
function nomMedecin(m, annuaire) {
    if (!m) return ''
    const nom = nomAffiche(m.medecin_nom, m.titre)
    if (nom) return nom
    const fiche = m.medecin_id && annuaire ? annuaire[String(m.medecin_id)] : null
    return fiche ? nomAffiche(fiche.nom, fiche.titre) : ''
}

// { uid: { nom, libelle, source, externe } } à partir de la réponse de la Clinique et de l'annuaire. L'auteur d'une
// prescription ou d'un soin est retenu s'il est praticien (infirmier compris), avant le médecin de consultation.
// annuaire = null : annuaire indisponible. Un auteur connu par son seul identifiant ne peut alors pas être vérifié :
// rien n'est affiché pour cette ligne (jamais le médecin de repli, qui pourrait ne pas être le vrai demandeur).
export function resoudre(lignes, annuaire) {
    const resultat = {}
    Object.keys(lignes || {}).forEach((uid) => {
        const l = lignes[uid] || {}
        let nom = nomAffiche(l.medecin_nom, l.titre)
        if (!nom && l.medecin_id) {
            if (!annuaire) return
            nom = nomMedecin(l, annuaire) || nomMedecin(l.repli, annuaire)   // auteur absent de l'annuaire des médecins : repli
        }
        if (!nom) return
        const libelle = l.externe ? 'Prescripteur externe : ' + nom : l.source === 'consultation' ? 'Médecin : ' + nom : 'Demandé par ' + nom
        resultat[uid] = { nom: nom, libelle: libelle, source: l.source || '', externe: !!l.externe }
    })
    return resultat
}

// Médecins demandeurs distincts (en-tête), dans l'ordre d'apparition. Les lignes de consultation en sont exclues :
// le médecin y est celui qui consulte, pas un demandeur.
export function resume(resolus) {
    const noms = []
    Object.keys(resolus || {}).forEach((uid) => {
        if (resolus[uid].source === 'consultation') return
        const nom = resolus[uid].nom
        if (nom && noms.indexOf(nom) < 0) noms.push(nom)
    })
    return noms
}
